import { useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { authService } from "../services/authService";

/**
 * Hook personalizado para manejar operaciones de autenticación
 * Proporciona métodos para login, logout, registro y actualización de perfil
 */
export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth debe ser usado dentro de un AuthProvider");
  }

  // Retornar directamente el contexto que ya tiene todo
  return context;
};
